import React from 'react';

import clsx from 'clsx';

import { CheckedIcon } from 'assets/images';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { Theme } from 'enums/Theme';

import styles from './FormHeader.module.scss';

interface FormHeaderProps {
  title?: string | JSX.Element;
  theme?: Theme;
  isBorderRounded?: boolean;
  subtitle?: string;
  percent?: number | ProgressBarStatus;
  classNameWrapper?: string;
  classNameTitle?: string;
  classNameHeader?: string;
}

const FormHeader = ({
  title,
  theme = Theme.Light,
  isBorderRounded = true,
  subtitle,
  percent,
  classNameWrapper,
  classNameTitle,
  classNameHeader,
  children,
}: React.PropsWithChildren<FormHeaderProps>) => {
  const renderTextProgressBarValue = (percentValue: number | ProgressBarStatus | undefined) => {
    switch (percentValue) {
      case ProgressBarStatus.Done:
        return (
          <div className={styles.checked}>
            <CheckedIcon className={styles.imageIcon} />
          </div>
        );

      case ProgressBarStatus.Failed:
        return <p className={styles.checked}>i</p>;

      case ProgressBarStatus.Warning:
        return <p className={styles.checkedWarning}>!</p>;

      case ProgressBarStatus.Error:
        return <p className={styles.checkedError}>!</p>;

      default:
        return null as never;
    }
  };

  return (
    <div className={clsx(styles.headerWrapper, classNameWrapper)}>
      <div
        className={clsx(
          {
            [styles.header]: isBorderRounded,
            [styles.headerNotRounded]: !isBorderRounded,
            [styles.headerDarkTheme]: theme === Theme.Dark,
          },
          classNameHeader,
        )}
      >
        {children || (
          <>
            <div className={clsx(styles.titles, theme === Theme.Dark && styles.titlesDarkTheme, classNameTitle)}>
              <h1 className={styles.headerTitle}>{title}</h1>
              {subtitle && <p>{subtitle}</p>}
            </div>
            {typeof percent === 'number' ? (
              <div
                className={
                  percent <= 50
                    ? clsx(styles.progressCircle, styles[`p${Math.round(percent)}`])
                    : clsx(styles.progressCircle, styles.over50, styles[`p${Math.round(percent)}`])
                }
              >
                <span className={styles.subtitleLarge}>{percent}%</span>
                <div className={styles.leftHalfClipper}>
                  <div className={styles.first50Bar} />
                  <div className={styles.valueBar} />
                </div>
              </div>
            ) : (
              renderTextProgressBarValue(percent)
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default FormHeader;
